import gql from "graphql-tag";

const PROJECTS_CONNECTION = gql`
  query projectsConnection(
    $where: ProjectWhereInput
    $orderBy: ProjectOrderByInput
    $skip: Int
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    projectsConnection(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
          owner {
            id
            name
            username
            avatar {
              id
              key
            }
            roles {
              id
              roleItems {
                feature
              }
            }
          }
          team {
            id
            name
            username
            avatar {
              id
              key
            }
            roles {
              id
              roleItems {
                feature
              }
            }
          }
          startDate
          endDate
          status
          priority
          tasks {
            id
            name
            status
          }
          milestones {
            id
            name
            dueDate
            status
          }
          activityLog
          createdAt
          updatedAt
        }
      }
      aggregate {
        count
      }
    }
    full: projectsConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default PROJECTS_CONNECTION;